import React, {Component } from "react";

import MainRoutes from './MainRoutes'
import Login from "./Login";
import {
  Link,
  BrowserRouter as Router
} from "react-router-dom"
import {Col, Row} from "react-bootstrap";

import { Provider, useDispatch } from 'react-redux'
import store from './store'
import Sidebar from "./Sidebar";
import { logout } from "./actions/auth.js";
import styled from "styled-components";
import TopBar from "./TopAndSideBar.js";
import { useState } from 'react';

const Nav = styled.div`
background: #15171c;
height: 50px;
display: flex;
justify-content: flex-start;
align-items: center;
`; 

/*
const WrapperApp = (props) => {

  const dispatch = useDispatch();
  const [sidebar, setSidebar] = useState(true);
  const showSidebar = () => setSidebar(!sidebar);

  const handleLogout = () => {
    //e.preventDefault();		
    
    dispatch(logout())
    .then(() => {
      //props.history.push("/");
      window.location.reload();
    })
    .catch((e) => {
      console.log(e);
    });
  };

  
	return (		
    <Router>
      <>
			<Nav style={{position:'sticky', top:'0',zIndex:'10'}}>

				<h4
					style={{width: "100%", 
							textAlign: "left",
              marginLeft: "20px",
							color: "#fff" }}
				>Fast Quoting System</h4>
        <TopBar sidebar={sidebar} showSidebar={showSidebar} />

			</Nav>  

      <Provider store={store}>         
      <Row 
        style={{
          display:"flex", 
          flexDirection:"row", 
          alignItems:"baseline", 
          width:"100%"
        }}
      >
        <Sidebar/>
        <MainRoutes user = {props.user}/>
      </Row>
      </Provider>
      </>
    </Router>
  )
}
*/


class WrapperApp extends Component {
  render() {
    return (      
    <>
      <Provider store={store}>
        <Col>
          <MainRoutes user = {this.props.user}/>
        </Col>
      </Provider>
    </>
      
    )
  }
};


/*
class WrapperApp extends Component {  
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }  
  
  handleLogout() {
    dispatch(logout())
    .then(() => {
      //props.history.push("/");
      window.location.reload();
    })
    .catch((e) => {
      console.log(e);
    }); 
    
    const dispatch = useDispatch();
  } 
  
  render() {
    return (
      <Router>
        <>
        <Provider store={store}>
        <h4
          style={{width: "100%", 
              textAlign: "center",
              marginLeft: "0%",
              color: "#fff" }}
        >
          Cabinet's Quick System
        </h4>
        <div style={{width:"50px"}}>

          <RiLogoutBoxRFill 
          size={25}
          onClick={this.handleLogout}/>
        </div>          
          <Col style={{display:"flex"}}>
            <Sidebar />
            <MainRoutes user = {this.props.user}/>
          </Col>
        </Provider>
        </>
      </Router>
    )
  }
};
*/


const App = () => {  
  return (    
    <>   
      <Provider store={store}>          
        <Login />          
      </Provider>     
    </>
  );
}

export {
  App,
  WrapperApp,
}